import { observer } from 'mobx-react';
import React, { useState, useEffect, useRef } from 'react';
import {
  GridColumnProps,
  SelectFilterComponent,
  SelectFloatingFilterComponent,
  SelectMode,
} from '@roc/ui';
import { InfiniteScrollGrid } from '@roc/feature-app-core';
import { useLoanStore } from '@roc/feature-loans-shared';

const noOpComparator = () => 0;

const columns: GridColumnProps[] = [
  {
    field: 'dealid',
    headerName: 'Loan Id',
    maxWidth: 125,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'dealName',
    headerName: 'Deal Name',
    minWidth: 275,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];

export const LoansForDrawRequestGrid = observer(({ onSelected }) => {
  const { loanStore } = useLoanStore();
  const [selectedLoan, setSelectedLoan] = useState(null);
  const syncedLoan = useRef(null);

  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
  };

  useEffect(() => {
    onSelected(selectedLoan);
  }, [selectedLoan]);

  const onRowSelected = e => {
    const { node } = e;
    if (node.data.dealid !== syncedLoan.current && !node.isSelected()) {
      return;
    } else if (node.isSelected()) {
      syncedLoan.current = node.data.dealid;
      setSelectedLoan(node.data.dealid);
    } else {
      syncedLoan.current = node.data.dealid;
      setSelectedLoan(null);
    }
  };

  return (
    <InfiniteScrollGrid
      columns={columns}
      frameworkComponents={frameworkComponents}
      store={loanStore.myFundedLoansForDrawsGridStore}
      onRowSelected={(row: any) => onRowSelected(row)}
      selectMode={SelectMode.SINGLE}
    />
  );
});

export default LoansForDrawRequestGrid;
